<template>
  <b-row no-gutters>
    <b-alert  
      class="position-fixed fixed-top m-0 rounded-0"
      variant="success"
      dismissible
      :show="successMessage !== null"
      @dismissed="resetMessages">
      {{successMessage}}
    </b-alert>
    <b-alert   
   
      class="position-fixed fixed-top m-0 rounded-0"
      variant="danger"
      dismissible
      :show="errorMessage !== null"
      @dismissed="resetMessages">
      {{errorMessage}}
    </b-alert>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MessageAlerts',
  computed: {
    ...mapState({
      errorMessage: state => state.progress.errorMessage,
      successMessage: state => state.progress.successMessage,
    }),
  },
  methods: {
    resetMessages() {
      this.$store.dispatch('progress/setSuccessMessage', null);
      this.$store.dispatch('progress/setErrorMessage', null);
    },
  },
  created() {
    const vm = this;
    if (vm.errorMessage !== null) {
      setTimeout(() => {
        vm.resetMessages();
      }, 10000);
    }
    if (vm.successMessage !== null) {
      setTimeout(() => {
        vm.resetMessages();
      }, 10000);
    }
  },
  watch: {
    errorMessage() {
      const vm = this;
      if (vm.errorMessage !== null) {
        setTimeout(() => {
          vm.resetMessages();
        }, 10000);
      }
    },
    successMessage() {
      const vm = this;
      if (vm.successMessage !== null) {
        setTimeout(() => {
          vm.resetMessages();
        }, 10000);
      }
    },
  },
};
</script>
